import { Component, Input } from '@angular/core';
import { Country, Relationship, School } from 'src/app/shared/models/lookup-data.model';
import { AccommodationWelfareDetails } from '../../models/accommodation-welfare-details';
import { ParentGuardianDetails } from '../../models/parent-guardian-details';
import { SchoolProgramPlacementDetails } from '../../models/school-program-placement-details';
import { Summary } from '../../models/summary.model';

@Component({
  selector: 'online-app-summary-print',
  templateUrl: './summary-print.component.html',
  styleUrls: ['./summary-print.component.scss']
})
export class SummaryPrintComponent{

  @Input() summary: Summary;
  @Input() relationships: Relationship[];
  @Input() countries: Country[];
  @Input() schools: School[];

  constructor() { }

  getYesNo(val: any): string {
    if (val === null || val === '') return '';
    return val === true ? 'Yes' : 'No';
  }

  englishLanguageTestMetadata = {
    IELTS: {
      code: 'IELTS',
      name: 'IELTS',
      reading: 'Reading',
      listening: 'Listening',
      speaking: 'Speaking',
      writing: 'Writing',
      total: 'Average Score'
    },
    TOEFL: {
      code: 'TOEFL',
      name: 'TOEFL iBT',
      reading: 'Reading',
      listening: 'Listening',
      speaking: 'Speaking',
      writing: 'Writing',
      total: 'Total Score'
    },
    AEAS: {
      code: 'AEAS',
      name: 'AEAS',
      reading: 'Reading Comprehension',
      listening: 'Listening',
      speaking: 'Speaking',
      writing: 'Written Essay',
      vocabulary: 'Vocabulary',
      total: 'Total Score'
    },
    EIKEN: {
      code: 'EIKEN',
      name: 'STEP Eiken',
      total: 'Grade'
    },
    CEFR: {
      code: 'CEFR',
      name: 'CEFR',
      total: 'Level'
    },
    OTHER: {
      code: 'OTHER',
      total: 'Grade / Average Score'
    }
  };

  isPrimaryYear() {
    if (this.summary.SchoolProgram && this.summary.SchoolProgram.YearOfEntryCode) {
      const yearOfEntryCode = this.summary.SchoolProgram.YearOfEntryCode;
      return yearOfEntryCode === 'Kindergarten'
        || yearOfEntryCode === 'Year1'
        || yearOfEntryCode === 'Year2'
        || yearOfEntryCode === 'Year3'
        || yearOfEntryCode === 'Year4'
        || yearOfEntryCode === 'Year5'
        || yearOfEntryCode === 'Year6';
    }
    return false;
  }

  showOrHideParentContactDetails(parentGuardian: ParentGuardianDetails): boolean {
    let showDetails: boolean = true;
    if (parentGuardian.IsParent && (parentGuardian.IsDeceased || !parentGuardian.HasLegalCustody)) {
      showDetails = false;
    }
    return showDetails;
  }

  getRelationship(relationshipCode: string): string {
    const selectedRelationship = this.relationships.find(r => r.Code === relationshipCode);
    return selectedRelationship ? selectedRelationship.Description : '';
  }

  getDate(dateInString: string): string {
    if (!dateInString) {
      return null;
    }

    const date = new Date(dateInString);
    const dateStr = date ? `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}` : '';
    return dateStr;
  }

  getGender(genderValue: string): string {
    if (genderValue === 'M') {
      return 'Male';
    } else if (genderValue === 'F') {
      return 'Female';
    }
    return '';
  }

  getCountryById(countryId: string): string {
    //console.log('countryId', countryId);
    const selectedCountry = this.countries.find(c => c.Id === countryId);
    //console.log('selectedCountry', selectedCountry);
    const countryDescription = selectedCountry ? selectedCountry.Description : '';
    //console.log('countryDescription', countryDescription);
    return selectedCountry ? selectedCountry.Description : '';
  }

  getAccommodationType(accommodation: AccommodationWelfareDetails): string {
    if (accommodation && accommodation.AccommodationTypeId) {
      switch (accommodation.AccommodationTypeId) {
        case 1:
          return 'Parent, will accompany the student on a guardian visa.';
        case 2:
          return 'Nominated Department of Home Affairs approved relative to provide accommodation, welfare and airport reception. (Direct Relative)';
        case 3:
          return `Nominated a person over 25 years of age residing in NSW to provide accommodation, welfare and airport reception. 
          Requested the NSW Department of Education to approve these arrangements as the welfare provider. (Parent Nomination)`;
        case 4:
          return `Requested the NSW Department of Education to arrange accommodation, welfare and airport reception. (Homestay)`;
        default:
          return '';
      }
    }
    return '';
  }

  getSchoolProgram(schoolProgramType: string): string {

    switch (schoolProgramType) {
      case 'International':
        return 'International Student Program';
      case 'StudyAbroad':
        return 'Study Abroad Program';
      default:
        return '';
    }
  }

  getSchoolProgramStartDate(schoolProgram: SchoolProgramPlacementDetails) {
    if (schoolProgram && schoolProgram.StartTermCode && schoolProgram.StartTermYear)
      return schoolProgram.StartTermDescription + ', ' + schoolProgram.StartTermYear;
    return '';
  }

  get Carer() {
    var selectedCarer = this.summary.Accommodation.Carers.length ? this.summary.Accommodation.Carers.find(c => c.CarerId === this.summary.Accommodation.SelectedCarerId) : null;

    if (!selectedCarer) {
      return {
        Description: '',
        GivenName: '',
        FamilyName: ''
      }
    }

    return selectedCarer;
  }

  getPreferredSchoolName(preferredSchoolId: string): string {
    if (this.schools) {
      const school = this.schools.find(school => school.Id == preferredSchoolId);
      if (school) {
        return school.Name;
      }
    }
    return '';
  }
}
